'use client'

import Script from "next/script"
// import { useAuthContext } from '@/app/firebase/AuthContext'

// List of user identifiers (emails or UIDs) who should have Microsoft Clarity disabled
// You can also use environment variable: process.env.NEXT_PUBLIC_CLARITY_DISABLED_USERS?.split(',')
// const DISABLED_USERS = process.env.NEXT_PUBLIC_CLARITY_DISABLED_USERS
//     ? process.env.NEXT_PUBLIC_CLARITY_DISABLED_USERS.split(',').map(u => u.trim())
//     : []


const MicrosoftClarity = () => {
    // const { user } = useAuthContext()

    // console.log('DISABLED_USERS', DISABLED_USERS)
    // console.log('user', user)

    // Check if we're on localhost (client-side only)
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname
        const isLocalhost = 
            hostname === 'localhost' || 
            hostname === '127.0.0.1' ||
            hostname.startsWith('192.168.') ||
            hostname.startsWith('10.') ||
            hostname.endsWith('.local')
        
        // Don't load Microsoft Clarity on localhost
        if (isLocalhost) {
            return null
        }
    }

    // Check if current user should have Clarity disabled
    // if (user && (user.uid || user.email)) {
    //     const userIdentifier = user.email || user.uid
    //     if (userIdentifier && DISABLED_USERS.includes(userIdentifier)) {
    //         return null
    //     }
    // }

    return (
        <Script
            id="microsoft-clarity-init"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `
                (function(c,l,a,r,i,t,y){
                    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                })(window, document, "clarity", "script", "${process.env.NEXT_PUBLIC_MICROSOFT_CLARITY_ID}");
                `,
            }}
        />
    )
}

export default MicrosoftClarity